(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vb-faq-section')) {
    customElements.define(
      'vb-faq-section',
      class VbFaqSection extends HTMLElement {
        connectedCallback() {
          this.searchInput = this.querySelector('[data-faq-search]');
          this.noResults = this.querySelector('[data-faq-no-results]');
          this.navItems = this.querySelectorAll('[data-faq-nav-item]');

          if (this.searchInput) {
            this.onSearch = this.handleSearch.bind(this);
            this.searchInput.addEventListener('input', this.onSearch);
          }
        }

        disconnectedCallback() {
          if (this.searchInput && this.onSearch) {
            this.searchInput.removeEventListener('input', this.onSearch);
          }
        }

        handleSearch(event) {
          const query = event.target.value.trim().toLowerCase();
          const items = this.querySelectorAll('[data-faq-item]');
          const categories = this.querySelectorAll('[data-faq-category]');
          let visibleCount = 0;

          items.forEach((item) => {
            const question = item.dataset.faqQuestion || '';
            const answer = item.dataset.faqAnswer || '';
            const matches = !query || question.includes(query) || answer.includes(query);

            item.hidden = !matches;
            if (matches) visibleCount += 1;
          });

          categories.forEach((category) => {
            const visibleItems = category.querySelectorAll('[data-faq-item]:not([hidden])');
            category.hidden = visibleItems.length === 0;

            const categoryId = category.id;
            const navItem = this.querySelector(`[data-faq-nav-item] a[href="#${categoryId}"]`)?.closest('[data-faq-nav-item]');
            if (navItem) navItem.hidden = category.hidden;
          });

          if (this.noResults) {
            this.noResults.hidden = visibleCount > 0 || !query;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-flyer-flipbook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('interactive-flyer-flipbook')) {
    customElements.define(
      'interactive-flyer-flipbook',
      class InteractiveFlyerFlipbook extends HTMLElement {
        connectedCallback() {
          this.activeMarker = null;
          this.currentIndex = 0;
          this.touchStartX = 0;
          this.touchDeltaX = 0;
          this.zoom = 1;
          this.minZoom = 1;
          this.maxZoom = 2;
          this.zoomStep = 0.25;

          this.onMarkerClick = this.onMarkerClick.bind(this);
          this.onQuickViewClick = this.onQuickViewClick.bind(this);
          this.onCloseClick = this.onCloseClick.bind(this);
          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onKeyDown = this.onKeyDown.bind(this);
          this.onResize = this.onResize.bind(this);
          this.onPrevClick = this.onPrevClick.bind(this);
          this.onNextClick = this.onNextClick.bind(this);
          this.onTouchStart = this.onTouchStart.bind(this);
          this.onTouchEnd = this.onTouchEnd.bind(this);
          this.onZoomIn = this.onZoomIn.bind(this);
          this.onZoomOut = this.onZoomOut.bind(this);
          this.onResetZoom = this.onResetZoom.bind(this);
          this.onPrint = this.onPrint.bind(this);
          this.onToggleGrid = this.onToggleGrid.bind(this);
          this.onCloseGrid = this.onCloseGrid.bind(this);
          this.onToggleMore = this.onToggleMore.bind(this);
          this.onFullscreen = this.onFullscreen.bind(this);
          this.onGridSelect = this.onGridSelect.bind(this);

          this.activeDay = Number(this.dataset.activeDay || 2);
          this.hasTeaser = this.dataset.hasTeaser === 'true';
          this.viewer = this.querySelector('[data-flyer-viewer]');
          this.teaserMedia = this.querySelector('[data-flyer-media="teaser"]');
          this.toolbar = this.querySelector('[data-flyer-toolbar]');
          this.pages = Array.from(this.querySelectorAll('[data-flyer-page]'));
          this.prevButtons = Array.from(this.querySelectorAll('[data-flyer-prev]'));
          this.nextButtons = Array.from(this.querySelectorAll('[data-flyer-next]'));
          this.pageCurrentEl = this.querySelector('[data-flyer-page-current]');
          this.stage = this.querySelector('[data-flyer-stage]');
          this.mediaNav = this.querySelector('[data-flyer-media-nav]');
          this.dots = Array.from(this.querySelectorAll('[data-flyer-dot]'));
          this.gridPanel = this.querySelector('[data-flyer-grid-panel]');
          this.gridList = this.querySelector('[data-flyer-grid-list]');
          this.gridButton = this.querySelector('[data-flyer-grid]');
          this.moreButton = this.querySelector('[data-flyer-more]');
          this.moreMenu = this.querySelector('[data-flyer-more-menu]');
          this.zoomInButton = this.querySelector('[data-flyer-zoom-in]');
          this.zoomOutButton = this.querySelector('[data-flyer-zoom-out]');

          this.syncFlyerMode();
          this.buildGrid();
          this.goTo(0, false);
          this.applyZoom();

          this.querySelectorAll('[data-flyer-marker]').forEach((marker) => {
            marker.addEventListener('click', this.onMarkerClick);
          });

          this.querySelectorAll('[data-flyer-quick-view]').forEach((button) => {
            button.addEventListener('click', this.onQuickViewClick);
          });

          this.querySelectorAll('[data-flyer-close]').forEach((button) => {
            button.addEventListener('click', this.onCloseClick);
          });

          this.prevButtons.forEach((button) => button.addEventListener('click', this.onPrevClick));
          this.nextButtons.forEach((button) => button.addEventListener('click', this.onNextClick));
          this.dots.forEach((dot) => {
            dot.addEventListener('click', (event) => {
              event.preventDefault();
              const index = Number(event.currentTarget.dataset.pageIndex || 0);
              this.goTo(index);
            });
          });
          if (this.zoomInButton) this.zoomInButton.addEventListener('click', this.onZoomIn);
          if (this.zoomOutButton) this.zoomOutButton.addEventListener('click', this.onZoomOut);
          if (this.gridButton) this.gridButton.addEventListener('click', this.onToggleGrid);
          if (this.moreButton) this.moreButton.addEventListener('click', this.onToggleMore);

          this.querySelectorAll('[data-flyer-print]').forEach((button) => {
            button.addEventListener('click', this.onPrint);
          });
          this.querySelectorAll('[data-flyer-reset-zoom]').forEach((button) => {
            button.addEventListener('click', this.onResetZoom);
          });
          this.querySelectorAll('[data-flyer-fullscreen]').forEach((button) => {
            button.addEventListener('click', this.onFullscreen);
          });
          this.querySelectorAll('[data-flyer-grid-close]').forEach((button) => {
            button.addEventListener('click', this.onCloseGrid);
          });

          if (this.stage) {
            this.stage.addEventListener('touchstart', this.onTouchStart, { passive: true });
            this.stage.addEventListener('touchend', this.onTouchEnd, { passive: true });
          }

          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('keydown', this.onKeyDown);
          window.addEventListener('resize', this.onResize);
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('keydown', this.onKeyDown);
          window.removeEventListener('resize', this.onResize);
        }

        syncFlyerMode() {
          if (!this.hasTeaser || !this.teaserMedia) return;

          const isActiveDay = new Date().getDay() === this.activeDay;

          if (this.viewer) this.viewer.hidden = !isActiveDay;
          if (this.toolbar) this.toolbar.hidden = !isActiveDay;
          if (this.mediaNav) this.mediaNav.hidden = !isActiveDay;
          this.teaserMedia.hidden = isActiveDay;

          if (!isActiveDay) {
            this.closeAll();
            this.closeGrid();
            this.closeMore();
          }
        }

        buildGrid() {
          if (!this.gridList) return;

          this.gridList.innerHTML = '';

          this.pages.forEach((page, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'interactive-flyer-flipbook__grid-item';
            button.dataset.pageIndex = String(index);
            button.setAttribute('aria-label', `Go to page ${index + 1}`);

            const thumbSrc = page.dataset.thumbSrc;
            if (thumbSrc) {
              const img = document.createElement('img');
              img.src = thumbSrc;
              img.alt = page.dataset.pageLabel || `Page ${index + 1}`;
              img.loading = 'lazy';
              img.className = 'interactive-flyer-flipbook__grid-image';
              button.appendChild(img);
            } else {
              const placeholder = document.createElement('span');
              placeholder.className = 'interactive-flyer-flipbook__grid-placeholder';
              placeholder.textContent = String(index + 1);
              button.appendChild(placeholder);
            }

            const label = document.createElement('span');
            label.className = 'interactive-flyer-flipbook__grid-label';
            label.textContent = `${index + 1}`;
            button.appendChild(label);

            button.addEventListener('click', this.onGridSelect);
            this.gridList.appendChild(button);
          });
        }

        goTo(index, animate = true) {
          if (!this.pages.length) return;

          const nextIndex = Math.max(0, Math.min(index, this.pages.length - 1));
          this.currentIndex = nextIndex;

          this.pages.forEach((page, i) => {
            const isActive = i === nextIndex;
            page.hidden = !isActive;
            page.classList.toggle('is-active', isActive);
            if (animate && isActive) {
              page.classList.remove('is-entering');
              void page.offsetWidth;
              page.classList.add('is-entering');
            }
          });

          if (this.pageCurrentEl) {
            this.pageCurrentEl.textContent = String(nextIndex + 1);
          }

          this.prevButtons.forEach((button) => {
            button.disabled = nextIndex === 0;
          });
          this.nextButtons.forEach((button) => {
            button.disabled = nextIndex >= this.pages.length - 1;
          });

          this.dots.forEach((dot, i) => {
            if (i === nextIndex) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });

          this.querySelectorAll('.interactive-flyer-flipbook__grid-item').forEach((item, i) => {
            item.classList.toggle('is-active', i === nextIndex);
          });

          this.closeAll();
        }

        applyZoom() {
          this.style.setProperty('--flyer-zoom', String(this.zoom));
          if (this.stage) {
            this.stage.classList.toggle('is-zoomed', this.zoom > 1);
          }
          if (this.zoomInButton) this.zoomInButton.disabled = this.zoom >= this.maxZoom;
          if (this.zoomOutButton) this.zoomOutButton.disabled = this.zoom <= this.minZoom;
        }

        onZoomIn(event) {
          event.preventDefault();
          this.zoom = Math.min(this.maxZoom, Math.round((this.zoom + this.zoomStep) * 100) / 100);
          this.applyZoom();
          this.closeMore();
        }

        onZoomOut(event) {
          event.preventDefault();
          this.zoom = Math.max(this.minZoom, Math.round((this.zoom - this.zoomStep) * 100) / 100);
          this.applyZoom();
          this.closeMore();
        }

        onResetZoom(event) {
          event.preventDefault();
          this.zoom = 1;
          this.applyZoom();
          this.closeMore();
        }

        onPrint(event) {
          event.preventDefault();
          this.closeMore();

          const page = this.pages[this.currentIndex];
          if (!page) return;

          const image =
            page.querySelector('.interactive-flyer__image--desktop:not([hidden])') ||
            page.querySelector('.interactive-flyer__image:not(.interactive-flyer__image--placeholder)') ||
            page.querySelector('img, svg');

          const printWindow = window.open('', '_blank', 'noopener,noreferrer,width=900,height=1200');
          if (!printWindow) return;

          const src = image && image.tagName === 'IMG' ? image.currentSrc || image.src : '';
          const title = page.dataset.pageLabel || `Flyer page ${this.currentIndex + 1}`;

          printWindow.document.write(`<!doctype html><html><head><title>${title}</title>
            <style>
              html, body { margin: 0; padding: 0; background: #fff; }
              img, svg { display: block; width: 100%; height: auto; max-width: 100%; }
              @page { margin: 0; }
            </style>
          </head><body></body></html>`);
          printWindow.document.close();

          if (src) {
            const img = printWindow.document.createElement('img');
            img.src = src;
            img.alt = title;
            img.onload = () => {
              printWindow.focus();
              printWindow.print();
            };
            printWindow.document.body.appendChild(img);
          } else if (image) {
            printWindow.document.body.appendChild(image.cloneNode(true));
            printWindow.focus();
            printWindow.print();
          }
        }

        onToggleGrid(event) {
          event.preventDefault();
          event.stopPropagation();
          this.closeMore();
          if (!this.gridPanel) return;

          if (this.gridPanel.hidden) {
            this.gridPanel.hidden = false;
            if (this.gridButton) this.gridButton.setAttribute('aria-expanded', 'true');
            document.documentElement.classList.add('interactive-flyer-grid-open');
          } else {
            this.closeGrid();
          }
        }

        onCloseGrid(event) {
          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }
          this.closeGrid();
        }

        closeGrid() {
          if (!this.gridPanel) return;
          this.gridPanel.hidden = true;
          if (this.gridButton) this.gridButton.setAttribute('aria-expanded', 'false');
          document.documentElement.classList.remove('interactive-flyer-grid-open');
        }

        onGridSelect(event) {
          event.preventDefault();
          const button = event.currentTarget;
          const index = Number(button.dataset.pageIndex || 0);
          this.goTo(index);
          this.closeGrid();
        }

        onToggleMore(event) {
          event.preventDefault();
          event.stopPropagation();
          if (!this.moreMenu) return;

          const willOpen = this.moreMenu.hidden;
          this.closeMore();
          if (willOpen) {
            this.moreMenu.hidden = false;
            if (this.moreButton) this.moreButton.setAttribute('aria-expanded', 'true');
          }
        }

        closeMore() {
          if (!this.moreMenu) return;
          this.moreMenu.hidden = true;
          if (this.moreButton) this.moreButton.setAttribute('aria-expanded', 'false');
        }

        onFullscreen(event) {
          event.preventDefault();
          this.closeMore();

          const target = this.viewer || this;
          if (!document.fullscreenElement) {
            if (target.requestFullscreen) target.requestFullscreen();
          } else if (document.exitFullscreen) {
            document.exitFullscreen();
          }
        }

        onPrevClick(event) {
          event.preventDefault();
          this.goTo(this.currentIndex - 1);
        }

        onNextClick(event) {
          event.preventDefault();
          this.goTo(this.currentIndex + 1);
        }

        onTouchStart(event) {
          if (this.zoom > 1) return;
          if (!event.changedTouches || !event.changedTouches[0]) return;
          this.touchStartX = event.changedTouches[0].clientX;
          this.touchDeltaX = 0;
        }

        onTouchEnd(event) {
          if (this.zoom > 1) return;
          if (!event.changedTouches || !event.changedTouches[0]) return;
          this.touchDeltaX = event.changedTouches[0].clientX - this.touchStartX;
          if (Math.abs(this.touchDeltaX) < 50) return;
          if (this.touchDeltaX > 0) this.goTo(this.currentIndex - 1);
          else this.goTo(this.currentIndex + 1);
        }

        isMobile() {
          return window.matchMedia('(max-width: 740px)').matches;
        }

        getPanel(marker) {
          const id = this.isMobile() ? marker.dataset.sheetId : marker.dataset.tooltipId;
          return id ? document.getElementById(id) : null;
        }

        onMarkerClick(event) {
          event.preventDefault();
          event.stopPropagation();

          if (this.viewer && this.viewer.hidden) return;

          const marker = event.currentTarget;
          if (this.activeMarker === marker) {
            this.closeAll();
            return;
          }

          this.openMarker(marker);
        }

        openMarker(marker) {
          this.closeAll();
          this.closeMore();

          const panel = this.getPanel(marker);
          if (!panel) return;

          marker.setAttribute('aria-expanded', 'true');
          marker.classList.add('is-active');
          panel.hidden = false;
          panel.classList.add('is-open');
          this.activeMarker = marker;

          if (this.isMobile()) {
            document.documentElement.classList.add('interactive-flyer-sheet-open');
          }
        }

        closeAll() {
          this.querySelectorAll('[data-flyer-marker].is-active').forEach((marker) => {
            marker.classList.remove('is-active');
            marker.setAttribute('aria-expanded', 'false');
          });

          this.querySelectorAll('[data-flyer-tooltip].is-open, [data-flyer-sheet].is-open').forEach((panel) => {
            panel.classList.remove('is-open');
            panel.hidden = true;
          });

          document.documentElement.classList.remove('interactive-flyer-sheet-open');
          this.activeMarker = null;
        }

        onCloseClick(event) {
          event.preventDefault();
          event.stopPropagation();
          this.closeAll();
        }

        onQuickViewClick(event) {
          event.preventDefault();
          event.stopPropagation();

          const button = event.currentTarget;
          const drawerId = button.getAttribute('aria-controls');
          const drawer = drawerId ? document.getElementById(drawerId) : null;

          this.closeAll();

          if (drawer) drawer.open = true;
        }

        onDocumentClick(event) {
          if (this.moreMenu && !this.moreMenu.hidden && !event.target.closest('.interactive-flyer-flipbook__more')) {
            this.closeMore();
          }

          if (!this.activeMarker) return;
          if (this.contains(event.target)) {
            if (event.target.closest('[data-flyer-tooltip], [data-flyer-marker], [data-flyer-sheet] .interactive-flyer__sheet-panel')) {
              return;
            }
          }
          this.closeAll();
        }

        onKeyDown(event) {
          if (event.key === 'Escape') {
            if (this.gridPanel && !this.gridPanel.hidden) {
              this.closeGrid();
              return;
            }
            if (this.moreMenu && !this.moreMenu.hidden) {
              this.closeMore();
              return;
            }
            if (this.activeMarker) {
              this.closeAll();
              return;
            }
          }

          if (this.viewer && this.viewer.hidden) return;
          if (event.target && ['INPUT', 'TEXTAREA', 'SELECT'].includes(event.target.tagName)) return;

          if (event.key === 'ArrowLeft') this.goTo(this.currentIndex - 1);
          if (event.key === 'ArrowRight') this.goTo(this.currentIndex + 1);
          if (event.key === '+' || event.key === '=') this.onZoomIn(event);
          if (event.key === '-' || event.key === '_') this.onZoomOut(event);
        }

        onResize() {
          if (this.activeMarker) this.closeAll();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-flyer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('interactive-flyer')) {
    customElements.define(
      'interactive-flyer',
      class InteractiveFlyer extends HTMLElement {
        connectedCallback() {
          this.activeMarker = null;
          this.onMarkerClick = this.onMarkerClick.bind(this);
          this.onQuickViewClick = this.onQuickViewClick.bind(this);
          this.onCloseClick = this.onCloseClick.bind(this);
          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onKeyDown = this.onKeyDown.bind(this);
          this.onResize = this.onResize.bind(this);

          this.activeDay = Number(this.dataset.activeDay || 2);
          this.hasTeaser = this.dataset.hasTeaser === 'true';
          this.activeMedia = this.querySelector('[data-flyer-media="active"]');
          this.teaserMedia = this.querySelector('[data-flyer-media="teaser"]');
          this.hotspots = this.querySelector('[data-flyer-hotspots]');

          this.syncFlyerMode();

          this.querySelectorAll('[data-flyer-marker]').forEach((marker) => {
            marker.addEventListener('click', this.onMarkerClick);
          });

          this.querySelectorAll('[data-flyer-quick-view]').forEach((button) => {
            button.addEventListener('click', this.onQuickViewClick);
          });

          this.querySelectorAll('[data-flyer-close]').forEach((button) => {
            button.addEventListener('click', this.onCloseClick);
          });

          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('keydown', this.onKeyDown);
          window.addEventListener('resize', this.onResize);
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('keydown', this.onKeyDown);
          window.removeEventListener('resize', this.onResize);
        }

        /**
         * Match weekly-deal-countdown: event day uses visitor local weekday.
         * Teaser shows on all other days when teaser images are configured.
         */
        syncFlyerMode() {
          if (!this.hasTeaser || !this.teaserMedia) return;

          const isActiveDay = new Date().getDay() === this.activeDay;

          if (this.activeMedia) {
            this.activeMedia.hidden = !isActiveDay;
          }

          this.teaserMedia.hidden = isActiveDay;

          if (this.hotspots) {
            this.hotspots.hidden = !isActiveDay;
          }

          if (!isActiveDay) {
            this.closeAll();
          }
        }

        isMobile() {
          return window.matchMedia('(max-width: 740px)').matches;
        }

        getPanel(marker) {
          const id = this.isMobile() ? marker.dataset.sheetId : marker.dataset.tooltipId;
          return id ? document.getElementById(id) : null;
        }

        onMarkerClick(event) {
          event.preventDefault();
          event.stopPropagation();

          if (this.hotspots && this.hotspots.hidden) return;

          const marker = event.currentTarget;
          if (this.activeMarker === marker) {
            this.closeAll();
            return;
          }

          this.openMarker(marker);
        }

        openMarker(marker) {
          this.closeAll();

          const panel = this.getPanel(marker);
          if (!panel) return;

          marker.setAttribute('aria-expanded', 'true');
          marker.classList.add('is-active');
          panel.hidden = false;
          panel.classList.add('is-open');
          this.activeMarker = marker;

          if (this.isMobile()) {
            document.documentElement.classList.add('interactive-flyer-sheet-open');
          }
        }

        closeAll() {
          this.querySelectorAll('[data-flyer-marker].is-active').forEach((marker) => {
            marker.classList.remove('is-active');
            marker.setAttribute('aria-expanded', 'false');
          });

          this.querySelectorAll('[data-flyer-tooltip].is-open, [data-flyer-sheet].is-open').forEach((panel) => {
            panel.classList.remove('is-open');
            panel.hidden = true;
          });

          document.documentElement.classList.remove('interactive-flyer-sheet-open');
          this.activeMarker = null;
        }

        onCloseClick(event) {
          event.preventDefault();
          event.stopPropagation();
          this.closeAll();
        }

        onQuickViewClick(event) {
          event.preventDefault();
          event.stopPropagation();

          const button = event.currentTarget;
          const drawerId = button.getAttribute('aria-controls');
          const drawer = drawerId ? document.getElementById(drawerId) : null;

          this.closeAll();

          if (drawer) {
            drawer.open = true;
          }
        }

        onDocumentClick(event) {
          if (!this.activeMarker) return;
          if (this.contains(event.target)) {
            const sheet = event.target.closest('[data-flyer-sheet]');
            if (sheet && event.target.matches('[data-flyer-close]')) return;
            if (event.target.closest('[data-flyer-tooltip], [data-flyer-marker], [data-flyer-sheet] .interactive-flyer__sheet-panel')) {
              return;
            }
          }
          this.closeAll();
        }

        onKeyDown(event) {
          if (event.key === 'Escape' && this.activeMarker) {
            this.closeAll();
          }
        }

        onResize() {
          if (this.activeMarker) {
            this.closeAll();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const EARTH_RADIUS_KM = 6371;

    const haversineKm = (lat1, lon1, lat2, lon2) => {
      const toRad = (deg) => (deg * Math.PI) / 180;
      const dLat = toRad(lat2 - lat1);
      const dLon = toRad(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

      return EARTH_RADIUS_KM * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    };

    const formatDistance = (km) => (km < 10 ? `${km.toFixed(1)} km` : `${Math.round(km)} km`);

    // `Number(null)` and `Number('')` are both 0, and 0 is a finite latitude — so a store
    // whose coordinates the directory emitted as null would otherwise be placed in the
    // Gulf of Guinea and sorted by the distance to it.
    const toCoordinate = (value) => {
      if (value === null || value === undefined || value === '') return null;

      const number = Number(value);

      return Number.isFinite(number) ? number : null;
    };

    const buildInlineItem = (store, labels) => {
      const item = document.createElement('li');
      item.className = 'pdp-spotlight__nearby-item';

      // Selects the store rather than linking to its page. In this list the shopper has
      // already decided what they want and is choosing where to get it, so the click that
      // matters is switching store — sending them to a store page instead put a detour in
      // front of the one action the list exists for.
      const name = document.createElement('button');
      name.type = 'button';
      name.className = 'pdp-spotlight__nearby-name';
      name.textContent = store.name || '';
      if (store.id) {
        name.setAttribute('data-nearby-select', String(store.id));
        if (labels.shopHere) {
          name.setAttribute('aria-label', `${labels.shopHere}: ${store.name || ''}`);
        }
      }
      item.appendChild(name);

      if (store.distanceKm != null) {
        const distance = document.createElement('span');
        distance.className = 'pdp-spotlight__nearby-distance';
        distance.textContent = formatDistance(store.distanceKm);
        item.appendChild(distance);
      }

      return item;
    };

    const buildDrawerItem = (store, labels) => {
      const item = document.createElement('li');
      item.className = 'pdp-nearby-drawer__item';

      const info = document.createElement('div');
      info.className = 'pdp-nearby-drawer__info';

      const name = document.createElement('p');
      name.className = 'pdp-nearby-drawer__name';
      if (store.id) {
        const select = document.createElement('button');
        select.type = 'button';
        select.className = 'pdp-nearby-drawer__name-button';
        select.textContent = store.name || '';
        select.setAttribute('data-nearby-select', String(store.id));
        name.appendChild(select);
      } else {
        name.textContent = store.name || '';
      }
      info.appendChild(name);

      const address = [store.address, store.city].filter(Boolean).join(', ');
      if (address) {
        const addressLine = document.createElement('p');
        addressLine.className = 'pdp-nearby-drawer__meta';
        addressLine.textContent = address;
        info.appendChild(addressLine);
      }

      const status = [labels.inStock, store.storeUntil].filter(Boolean).join(' · ');
      if (status) {
        const statusLine = document.createElement('p');
        statusLine.className = 'pdp-nearby-drawer__meta';
        statusLine.textContent = status;
        info.appendChild(statusLine);
      }

      item.appendChild(info);

      const aside = document.createElement('div');
      aside.className = 'pdp-nearby-drawer__aside';

      if (store.distanceKm != null) {
        const distance = document.createElement('span');
        distance.className = 'pdp-nearby-drawer__distance';
        distance.textContent = formatDistance(store.distanceKm);
        aside.appendChild(distance);
      }

      if (labels.shopHere && store.id) {
        const select = document.createElement('button');
        select.type = 'button';
        select.className = 'pdp-nearby-drawer__select';
        select.textContent = labels.shopHere;
        // The handler is delegated on `document` rather than bound here: `drawer-content`
        // reparents itself to <body> and, when an element of the same id is already
        // there, does it by cloning — which would drop a listener attached to the button.
        select.setAttribute('data-nearby-select', String(store.id));
        aside.appendChild(select);
      }

      item.appendChild(aside);

      return item;
    };

    const renderNearbyStores = (container) => {
      const dataElement = container.querySelector('[data-nearby-stores-data]');
      if (!dataElement) return;

      let payload;
      try {
        payload = JSON.parse(dataElement.textContent);
      } catch (error) {
        return;
      }

      const stores = Array.isArray(payload?.stores) ? payload.stores : [];
      if (!stores.length) return;

      const originLat = toCoordinate(payload?.origin?.latitude);
      const originLng = toCoordinate(payload?.origin?.longitude);
      const hasOrigin = originLat !== null && originLng !== null;

      const ranked = stores
        .map((store) => {
          const lat = toCoordinate(store.latitude);
          const lng = toCoordinate(store.longitude);
          const measurable = hasOrigin && lat !== null && lng !== null;

          return Object.assign({}, store, {
            distanceKm: measurable ? haversineKm(originLat, originLng, lat, lng) : null,
          });
        })
        .sort((a, b) => {
          // A store with no coordinates sinks to the bottom rather than sorting as if it
          // were zero kilometres away and leading the list.
          if (a.distanceKm != null && b.distanceKm != null) return a.distanceKm - b.distanceKm;
          if (a.distanceKm != null) return -1;
          if (b.distanceKm != null) return 1;
          return String(a.name || '').localeCompare(String(b.name || ''));
        });

      // The radius is a hard limit. It used to fall back to the whole province when
      // nothing was inside it, which meant "8 stores with stock" could be answered by a
      // store a four-hour drive away — true, and useless to someone deciding where to go
      // this afternoon. Nothing within range now means nothing is offered.
      const radiusKm = Number(payload?.radiusKm);
      const preferred =
        Number.isFinite(radiusKm) && radiusKm > 0
          ? ranked.filter((store) => store.distanceKm != null && store.distanceKm <= radiusKm)
          : ranked;

      const labels = payload?.labels || {};
      const storeBlock = container.closest('.pdp-spotlight__store');
      const copyEl = storeBlock ? storeBlock.querySelector('.pdp-spotlight__store-copy') : null;

      // Every count on this block has to describe the list under it. The server counts the
      // whole province because Liquid cannot measure distance, so once the radius is
      // applied here the copy is rewritten from the same filtered set the shopper sees —
      // otherwise the line reads "8 nearby stores" above three of them.
      if (preferred.length === 0) {
        // Only claim nothing is nearby when the distances were actually measurable. With
        // no origin coordinates every store fails the radius test, and reporting that as
        // "no store near you has this" states an absence that was never checked — the
        // server's own count stands instead, which is what this block showed before.
        if (hasOrigin && copyEl && labels.noneNearby) copyEl.textContent = labels.noneNearby;
        return;
      }

      if (copyEl && labels.countLine) {
        copyEl.textContent = labels.countLine.replace('__COUNT__', String(preferred.length));
      }

      const inlineCount = Number(payload?.inlineCount) > 0 ? Number(payload.inlineCount) : 3;
      const inlineStores = preferred.slice(0, inlineCount);

      const inlineList = container.querySelector('[data-nearby-inline]');
      if (inlineList) {
        const fragment = document.createDocumentFragment();
        inlineStores.forEach((store) => fragment.appendChild(buildInlineItem(store, labels)));
        inlineList.replaceChildren(fragment);
      }

      const drawer = payload?.drawerId ? document.getElementById(payload.drawerId) : null;
      const fullList = drawer ? drawer.querySelector('[data-nearby-full]') : null;
      if (fullList) {
        const fragment = document.createDocumentFragment();
        preferred.forEach((store) => fragment.appendChild(buildDrawerItem(store, labels)));
        fullList.replaceChildren(fragment);
      }

      const moreButton = container.querySelector('[data-nearby-more]');
      if (moreButton && fullList && preferred.length > inlineStores.length) {
        if (labels.seeAll) {
          moreButton.textContent = labels.seeAll.replace('__COUNT__', String(preferred.length));
        }
        moreButton.hidden = false;
      }

      container.hidden = false;
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest?.('[data-nearby-select]');
      if (!trigger) return;

      window.dispatchEvent(
        new CustomEvent('age-gate:select-store', {
          detail: { storeId: trigger.getAttribute('data-nearby-select') },
        })
      );
    });

    document.querySelectorAll('.pdp-spotlight').forEach((root) => {
      root.querySelectorAll('[data-nearby-stores]').forEach(renderNearbyStores);

      // No open-store-picker binding here: assets/custom.js handles that action globally
      // by delegation, and a second binding would dispatch the event twice.
      root.querySelectorAll('[data-action="switch-to-delivery"]').forEach((button) => {
        button.addEventListener('click', () => {
          window.dispatchEvent(new CustomEvent('product:switch-to-delivery'));
        });
      });

      root.querySelectorAll('[data-action="scroll-store-info"]').forEach((button) => {
        button.addEventListener('click', () => {
          const target =
            document.querySelector('.shopify-section--store-info') ||
            document.querySelector('[id*="store_info"]');

          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      root.querySelectorAll('[data-description-collapse]').forEach((button) => {
        button.addEventListener('click', () => {
          const details = button.closest('.pdp-spotlight__description-toggle');
          if (details) {
            details.open = false;
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-content-carousel')) {
    customElements.define(
      'product-content-carousel',
      class ProductContentCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.product-content__track');
          this.navigation = this.querySelector('.product-content__nav');

          if (!this.track || !this.navigation) return;

          this.cards = Array.from(this.querySelectorAll('.pc-buy-with-card'));
          this.previousButton = this.navigation.querySelector('[data-action="prev"]');
          this.nextButton = this.navigation.querySelector('[data-action="next"]');
          this.onPrevious = () => this.scroll(-1);
          this.onNext = () => this.scroll(1);
          this.onScroll = () => {
            cancelAnimationFrame(this.updateFrame);
            this.updateFrame = requestAnimationFrame(() => this.updateNavigation());
          };

          this.addEventListener('prev-next:prev', this.onPrevious);
          this.addEventListener('prev-next:next', this.onNext);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });

          this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
          this.resizeObserver.observe(this.track);
          requestAnimationFrame(() => this.updateNavigation());
        }

        disconnectedCallback() {
          this.removeEventListener('prev-next:prev', this.onPrevious);
          this.removeEventListener('prev-next:next', this.onNext);
          this.track?.removeEventListener('scroll', this.onScroll);
          this.resizeObserver?.disconnect();
          cancelAnimationFrame(this.updateFrame);
        }

        scroll(direction) {
          const firstCard = this.cards[0];
          if (!firstCard) return;

          const styles = getComputedStyle(this.querySelector('.product-content__cards'));
          const gap = parseFloat(styles.columnGap) || 0;
          const step = firstCard.getBoundingClientRect().width + gap;
          const directionMultiplier = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;

          this.track.scrollBy({
            left: step * direction * directionMultiplier,
            behavior: 'smooth',
          });
        }

        updateNavigation() {
          const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const scrollPosition = Math.min(maxScroll, Math.abs(this.track.scrollLeft));
          const hasMultipleProducts = this.cards.length > 1;
          const isScrollable = maxScroll > 1;

          this.navigation.hidden = !hasMultipleProducts || !isScrollable;
          this.previousButton.disabled = scrollPosition <= 1;
          this.nextButton.disabled = scrollPosition >= maxScroll - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weekly-deal-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('weekly-deal-countdown')) {
    customElements.define(
      'weekly-deal-countdown',
      class WeeklyDealCountdown extends HTMLElement {
        connectedCallback() {
          this.headingEl = this.querySelector('[data-wdc-heading]');
          this.timerEl = this.querySelector('[data-wdc-timer]');
          this.daysEl = this.querySelector('[data-wdc-days]');
          this.hoursEl = this.querySelector('[data-wdc-hours]');
          this.minutesEl = this.querySelector('[data-wdc-minutes]');
          this.secondsEl = this.querySelector('[data-wdc-seconds]');
          this.liveRegion = this.querySelector('[data-wdc-live-region]');

          this.endDay = Number(this.dataset.endDay || 2);
          this.headingComing = this.dataset.headingComing || '';
          this.headingLive = this.dataset.headingLive || '';

          this.tick = this.tick.bind(this);
          this.tick();
          this.intervalId = window.setInterval(this.tick, 1000);
        }

        disconnectedCallback() {
          if (this.intervalId) {
            window.clearInterval(this.intervalId);
          }
        }

        /**
         * Event day lasts the full selected weekday.
         * Countdown restarts the following day at 00:00:01 local time,
         * targeting the next selected weekday at 00:00:00.
         */
        getMode(now) {
          const day = now.getDay();
          const nextDay = (this.endDay + 1) % 7;

          if (day === this.endDay) {
            return 'live';
          }

          if (day === nextDay) {
            const msIntoDay =
              now.getHours() * 3600000 +
              now.getMinutes() * 60000 +
              now.getSeconds() * 1000 +
              now.getMilliseconds();

            if (msIntoDay < 1000) {
              return 'live';
            }
          }

          return 'countdown';
        }

        getNextEndDate(now) {
          const target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
          let daysUntil = (this.endDay - now.getDay() + 7) % 7;

          if (daysUntil === 0) {
            daysUntil = 7;
          }

          target.setDate(target.getDate() + daysUntil);
          return target;
        }

        pad(value) {
          return String(Math.max(0, value));
        }

        setLiveState() {
          this.classList.add('weekly-deal-countdown--live');
          this.classList.remove('weekly-deal-countdown--countdown');

          if (this.headingEl) {
            this.headingEl.textContent = this.headingLive;
          }

          if (this.timerEl) {
            this.timerEl.hidden = true;
          }

          if (this.liveRegion) {
            this.liveRegion.textContent = this.headingLive;
          }
        }

        setCountdownState(diffMs) {
          this.classList.add('weekly-deal-countdown--countdown');
          this.classList.remove('weekly-deal-countdown--live');

          if (this.headingEl) {
            this.headingEl.textContent = this.headingComing;
          }

          if (this.timerEl) {
            this.timerEl.hidden = false;
          }

          const totalSeconds = Math.max(0, Math.floor(diffMs / 1000));
          const days = Math.floor(totalSeconds / 86400);
          const hours = Math.floor((totalSeconds % 86400) / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;

          if (this.daysEl) this.daysEl.textContent = this.pad(days);
          if (this.hoursEl) this.hoursEl.textContent = this.pad(hours);
          if (this.minutesEl) this.minutesEl.textContent = this.pad(minutes);
          if (this.secondsEl) this.secondsEl.textContent = this.pad(seconds);

          if (this.liveRegion && seconds % 30 === 0) {
            this.liveRegion.textContent = `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds remaining`;
          }
        }

        tick() {
          const now = new Date();
          const mode = this.getMode(now);

          if (mode === 'live') {
            this.setLiveState();
            return;
          }

          const endDate = this.getNextEndDate(now);
          this.setCountdownState(endDate.getTime() - now.getTime());
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
